export default __webpack_public_path__ + "static/miniLogo-1ad330627aa9ea1d940098a2382f872c.png";